import {call, put, takeLatest, fork, all, delay,} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as PostService from './../services/postService';
import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import {PATHS, SAGA_DELAY_TIMEOUT} from '../constants/Define';
import {notification} from 'antd'
import {
    setListPosts as setListPostsAction,
    setPostDetail as setPostsDetailAction,
} from './../actions/postAction';
import history from '../helpers/history';

function* getListPost() {
    yield takeLatest(Types.POST_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const pageSize = action.filters.pageSize ? action.filters.pageSize > 10 ? action.filters.pageSize : undefined : undefined;
        const pageIndex = action.filters.pageIndex ? action.filters.pageIndex > 1 ? action.filters.pageIndex : undefined : undefined;
        const params = {
            ...action.filters,
            pageSize, pageIndex,
        };
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(PostService.getPosts, params);
        yield put(setListPostsAction(result));
    }, errorHandlePost(Types.POST_LIST_FAIL)))
}

function* getPostDetail() {
    yield takeLatest(Types.POST_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PostService.getPostDetail, action.id);
        yield put(setPostsDetailAction(result));
    }, errorHandlePost(Types.POST_DETAIL_FAIL)))
}

function* updatePostDetail() {
    yield takeLatest(Types.POST_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PostService.updatePostDetail, action.post.post);
        Func.sagaSuccessMessage({ action,
            message: `${i18n.t('notification.updateSuccess')}`,
            description: `${i18n.t('item.post.title_page')} "${action.post.post.title}"`
        })
        yield put(setPostsDetailAction(result));
        history.push(PATHS.POST.LIST.path);
        history.go();
    }, errorHandlePost(Types.POST_DETAIL_FAIL)))
}

function* createPostDetail() {
    yield takeLatest(Types.POST_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PostService.createPostDetail, action.post);
        Func.sagaSuccessMessage({ action,
            message: `${i18n.t('notification.createSuccess')}`,
            description: `${i18n.t('item.post.title_page')} "${action.post.title}"`
        })
        yield put(setPostsDetailAction(result));
    }, errorHandlePost(Types.POST_DETAIL_FAIL)))
}

function* deletePostDetail() {
    yield takeLatest(Types.POST_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PostService.deletePostDetail, action.post);
        Func.sagaSuccessMessage({ action,
            message: `${i18n.t('notification.removeSuccess')}`,
        });
        const params = {
            ...action.filters,
            PageIndex: action.filters.pageIndex && action.filters.pageIndex > 1 ? action.filters.pageIndex : undefined,
            PageSize: action.filters.pageSize && action.filters.pageSize > 10 ? action.filters.pageSize : undefined,
        };
        const resultList = yield call(PostService.getPosts, params);
        yield put(setListPostsAction(resultList));
    }, errorHandlePost(Types.POST_DETAIL_FAIL)));
}

// TRANSLATE
function* createPostTranslate() {
    yield takeLatest(Types.POST_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(PostService.createPostTranslate, action.post);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.post.translate.languageName);
        yield put({ type: Types.POST_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.POST_DETAIL_ACTION, id: action.post.id });
    }, errorHandlePost(Types.POST_FAIL)))
}

function* updatePostTranslate() {
    yield takeLatest(Types.POST_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(PostService.updatePostTranslate, action.post);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.post.translate.languageName);
        yield put({ type: Types.POST_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.POST_DETAIL_ACTION, id: action.post.id });
    }, errorHandlePost(Types.POST_FAIL)))
}

function* deletePostTranslate() {
    yield takeLatest(Types.POST_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(PostService.deletePostTranslate, action.post.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.post.translate.languageName);
        yield put({ type: Types.POST_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.POST_DETAIL_ACTION, id: action.post.id });
    }, errorHandlePost(Types.POST_FAIL)))
}

function errorHandlePost(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'post');
}

export function* postSaga() {
    yield all([
        fork(getListPost),
        fork(getPostDetail),
        fork(updatePostDetail),
        fork(createPostDetail),
        fork(deletePostDetail),

        fork(createPostTranslate),
        fork(updatePostTranslate),
        fork(deletePostTranslate),
    ])
}
